( function () {
   
  'use strict';
  ( function ( $ ) {
    new Swiper(".clothing-product-Swiper", {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next.three',
        prevEl: '.swiper-button-prev.three',
      },
      breakpoints: {
        580: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1061: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1351: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      },
    });
  } )( jQuery );
} )();